import { useRef, useState, useEffect } from "react";
import { FileUpload } from "@diditusa/shared/types/uploadsTypes";
import {
  GetUploadUrlRequest,
  ImageEntity,
  ImagePurpose,
} from "@diditusa/shared/types/uploadsTypes";
import {
  useFileUploadCompleteMutation,
  useGetUploadUrlMutation,
} from "@diditusa/shared/api/uploadApi";
import { Avatar, Box, Button, Typography } from "@mui/material";
import LoadingIndicator from "@diditusa/shared/web_components/LoadingIndicator/loadingIndicator";

interface Props {
  entity: ImageEntity;
  purpose: ImagePurpose;
  productId?: number;
  userId?: string;
  companyId?: number;
  imageUrl?: string;
  onUploadComplete?: (fileId: number) => void;
  value?: FileUpload[];
  withPreview?: boolean;
  buttonText?: string;
}
const ImageUploadInput = ({
  onUploadComplete = () => {},
  value = [],
  entity,
  purpose,
  productId,
  userId,
  companyId,
  imageUrl,
  withPreview = true,
  buttonText = "Change",
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [getFileUploadUrl, { data: uploadUrlResp, ...getFileUploadUrlState }] =
    useGetUploadUrlMutation();
  const [
    sendFileUploadComplete,
    { data: uploadedFile, ...sendFileUploadCompleteState },
  ] = useFileUploadCompleteMutation();
  const [curFile, setCurFile] = useState<File | undefined>();
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const onUploadClick = () => {
    fileInputRef.current?.click();
  };

  useEffect(() => {
    if (uploadUrlResp) {
      uploadFile();
    }
  }, [uploadUrlResp]);

  useEffect(() => {
    if (uploadedFile) {
      setCurFile(undefined);
    }
  }, [uploadedFile]);

  const uploadFile = async () => {
    if (!uploadUrlResp || !curFile) {
      return;
    }
    try {
      await fetch(uploadUrlResp.signedUrl, {
        method: "PUT",
        body: curFile.slice(0),
      });
      await sendFileUploadComplete(uploadUrlResp.fileId);
      onUploadComplete(uploadUrlResp.fileId);
      setIsLoading(false);
    } catch (err: any) {
      setError(err.toString());
      setIsLoading(false);
      console.error(err);
    }
  };

  const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    if (file.size >= 3 * 1024 * 1024) {
      alert("Max file size is 3 mb");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result as string);
    reader.readAsDataURL(file);
    setCurFile(file);
    setIsLoading(true);
    const name = file.name;
    const fileUploadReq: GetUploadUrlRequest = {
      fileName: file.name,
      userId,
      productId,
      companyId,
      purpose,
      entity,
    };
    getFileUploadUrl(fileUploadReq);
    if (getFileUploadUrlState.isError) {
      alert(
        `Error uploading file: ${(getFileUploadUrlState as any).data.message}`
      );
      return;
    }
  };

  const handleDeleteConfirmed = () => {
    //delete file
    // const fileId = value[0].id;
    // sendDeleteFileRequest({fileId});
    setShowDeleteConfirmationModal(false);
  };

  const handleDeleteCanceled = () => {
    setShowDeleteConfirmationModal(false);
  };

  const getContents = () => {
    // if (curFile || getFileUploadUrlState.isLoading || sendFileUploadCompleteState.isLoading) {
    //   return (
    //     <Box>
    //       <Typography style={{ alignSelf: 'center', marginLeft: 8 }}>{curFile?.name}</Typography>
    //     </Box>
    //   );
    // }

    // if (value && value.length > 0) {
    return (
      <Box flex={1}>
        <Box display="flex">
          {withPreview &&
            (imagePreview ? (
              <Avatar
                src={imagePreview}
                alt="Preview"
                variant="rounded"
                sx={{ width: 250, height: 250, my: 2 }}
              />
            ) : (
              <Box
                sx={{
                  height: "250px",
                  width: "250px",
                  aspectRatio: "2/3",
                  borderRadius: 2,
                  backgroundImage: imagePreview
                    ? imagePreview
                    : `url(${imageUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundColor: "lightgray",
                }}
              >
                {imagePreview === undefined && imageUrl === undefined && (
                  <Typography>No Image uploaded</Typography>
                )}
              </Box>
            ))}
          <LoadingIndicator isVisible={isLoading} />
          {error && <Typography>{error}</Typography>}
          <Button sx={{ mt: "auto", height: "30px" }} onClick={onUploadClick}>
            {buttonText}
          </Button>
        </Box>

        <Box>
          {/* <Button style={{ paddingRight: 2 }} type='link' onClick={onUploadClick}>
              Replace
            </Button>
            <Typography style={{ alignSelf: 'center' }}>|</Typography> */}
          {/* <Button
              style={{ paddingLeft: 2 }}
              type='link'
              onClick={() => setShowDeleteConfirmationModal(true)}
            >
              Delete
            </Button> */}
        </Box>
      </Box>
    );
    // }
    // return (
    //   <Box justifyContent={'space-between'}>
    //     <Box>
    //       <Typography>No Image Uploaded</Typography>
    //     </Box>
    //     <Button onClick={onUploadClick}>Upload</Button>
    //   </Box>
    // );
  };
  return (
    <>
      <input
        type="file"
        hidden
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={onFileChange}
      />
      {/* <Modal
        title='Delete this file?'
        open={showDeleteConfirmationModal}
        onOk={handleDeleteConfirmed}
        onCancel={handleDeleteCanceled}
      >
        <Typography>You will lose any data you entered.</Typography>
      </Modal> */}
      {getContents()}
    </>
  );
};

export default ImageUploadInput;
